import type { ComponentProps } from "react";
import type { Control } from "react-hook-form";
import { t } from "ttag";

import { Checkbox, Form } from "@/shared/ui";

interface FieldValue {
  smsMarketingConsent?: boolean;
}

type SmsMarketingConsentControl<T> = T extends FieldValue ? Control<T> : never;

type SmsMarketingConsentFieldProps<T extends FieldValue> = ComponentProps<
  typeof Form.Item
> & {
  control: SmsMarketingConsentControl<T>;
};
export const SmsMarketingConsentField = <T extends FieldValue>({
  control,
  ...props
}: SmsMarketingConsentFieldProps<T>) => {
  return (
    <Form.Field
      control={control}
      name="smsMarketingConsent"
      render={({ field: { value, onChange, ...rest } }) => (
        <Form.Item {...props}>
          <Form.Control>
            <Checkbox.Item {...rest} checked={value} onCheckedChange={onChange}>
              <Checkbox.Label className="translate-y-1 text-xs">
                {t`I'd also like to receive occasional promotions via call and text message. Opt out anytime.`}
              </Checkbox.Label>
            </Checkbox.Item>
          </Form.Control>
        </Form.Item>
      )}
    />
  );
};
